module.exports = __webpack_public_path__ + "static/media/CSI-NL.7913e369.jpg";